import type { UserProfile, UserProfileRequest } from "@shared/schemas";
import { axios } from ".";

const USER_PROFILE_BASE_URL = "/api/v1/user-profile/bc-user-profile";
const ROASTER_LOGO_URL = "/api/v1/user-profile/bc-roaster-logo";

interface GetUserProfileParams {
  userId: string;
  vendorKey: string;
}

export const getUserProfile = async ({ userId, vendorKey }: GetUserProfileParams): Promise<UserProfile> => {
  const response = await axios.get<{ data: UserProfile }>(USER_PROFILE_BASE_URL, {
    params: { userId, vendorKey },
  });
  return response.data.data;
};

export const updateUserProfile = async (userProfile: UserProfileRequest): Promise<void> => {
  await axios.patch(USER_PROFILE_BASE_URL, userProfile);
};

export const uploadRoasterLogo = async (file: File): Promise<void> => {
  const buffer = await file.arrayBuffer();
  await axios.post(ROASTER_LOGO_URL, buffer, {
    headers: {
      "Content-Type": file.type,
      "x-filename": file.name,
    },
  });
};
